interface ResolvableOrder {
  status?: { slug?: string | null } | null;
  merchant_action_required?: unknown;
}

/**
 * BOXY-49 — the ONE rule for when the order page header shows RESOLVE: the
 * order is on hold and needs merchant action. The Updates tab hides its own
 * Resolve by the same rule, so the page never shows two (or none by drift).
 */
export const headerShowsResolve = (order: ResolvableOrder | null | undefined): boolean =>
  order?.status?.slug === 'on-hold' && order.merchant_action_required === 1;
